import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export default function ForgotPassword() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect(); // user zobaczy w Auth0 "Forgot password?"
  }, [loginWithRedirect]);

  return <div>Przekierowuję do ekranu logowania…</div>;
}
